export const PAGEACTIONFLAGS = "PAGEACTIONFLAGS";
export const PAGEACTIONFLAGS_SUCCESS = "PAGEACTIONFLAGS_SUCCESS";
export const PAGEACTIONFLAGS_ERROR = "PAGEACTIONFLAGS_ERROR";
export const PAGEACTIONFLAGS_CLEAR_DATA = "PAGEACTIONFLAGS_CLEAR_DATA";

export const POST_ACTION_FLAGS = "POST_ACTION_FLAGS";
export const POST_ACTION_FLAGS_SUCCESS = "POST_ACTION_FLAGS_SUCCESS";
export const POST_ACTION_FLAGS_ERROR = "POST_ACTION_FLAGS_ERROR";
export const POST_ACTION_FLAGS_CLEAR_DATA = "POST_ACTION_FLAGS_CLEAR_DATA";
